export interface IVideoState {
  loading: boolean;
}

const defaultState = {
  loading: false,
};

export const getDefaultVideoState = () => defaultState;
